import _ from 'lodash';
import {
  RECEIVE_IFP_CROSS_SELL,
} from '../actions/ifpCrossSell';

const initialState = {
  all: [],
};

export default function ifpCrossSell(state = initialState, action) {
  Object.freeze(state);

  switch (action.type) {
    case RECEIVE_IFP_CROSS_SELL: {
      return {
        all: _.uniqBy([
          action.ifpCrossSell,
          ...state.all,
        ], 'target_app_id'),
      };
    }
    default:
      return state;
  }
}
